<template>
  <div>
    <!-- <div>社区简报</div> -->
    <!-- <div>{{cookieb}}-----</div> -->
    <!-- <div>{{cookieb.mId}}----------</div> -->
    
    <div id="region_report">
      <div class="flow_all" @touchmove.prevent v-if="maskshow"></div>
      <div class="region_header" v-clickoutside="handleClose">
        <div>
          <span class="chooseregion half_border" @click="showlist">
            <i class="iconfont iconicons-dizhi"></i>
            <span  style="margin-left:-5px;">{{region}}</span>
            <i class="iconfont iconicon-arrow-down spec_icon" v-if="!canshow"></i>
            <i class="iconfont iconicon-arrow-up spec_icon" v-else></i>
          </span>
          <!-- <mt-cell-swipe title="标题文字" ></mt-cell-swipe> -->
        </div>
        <div class="chooseList" v-if="canshow">
          <ul>
            <li class="choose_item" v-for="item in regionList" :key="item.projectId" @click="closelist(item)">{{item.projectName}}</li>
          </ul>
        </div>
      </div>

      <div class="region_title">{{regionuser}}</div>
      
      <!-- 报事情况卡片 -->
      <div class="card_big">
        <div class="card_header">
          <i class="iconfont iconicon-baoshiwanchengqingkuang icon_blue"></i>
          <span class="header_text">报事情况</span>
        </div>
        <div class="card_tab">
          <div class="tab_left">
            <p class="tab_title">业主标准报事及时完成率</p>
            <p class="tab_num">{{timelyfinish.ownerOrder?timelyfinish.ownerOrder:0}}%</p>
          </div>
          <div class="tab_right">
            <p class="tab_title">公司中排名</p>
            <p class="tab_num">{{timelyfinish.topNum?timelyfinish.topNum:'--'}}</p>
          </div>
        </div>
        <div class="card_best3">
          <div class="best3_title">公司中TOP3社区</div>
          <div class="best3_list" v-if="timelyfinish.mobileBiTopList&&timelyfinish.mobileBiTopList.length">
            <div class="best3_item" v-for="item in timelyfinish.mobileBiTopList" :key="item.regionId">
              <div class="item_num">{{item.num}}</div>
              <div class="item_name">{{item.regionName}}</div>
              <div class="item_value">{{item.ownerOrder}}%</div>
            </div>
          </div>
          <div class="best3_list" v-else>
            <div class="best3_item">
              <span class="nullitem">--</span>
            </div>
          </div>
        </div>
        <div class="card_tab">
          <div class="tab_left">
            <p class="tab_title">业主标准报事线上报事率</p>
            <p class="tab_num">{{onlinerate.ownerOrder?onlinerate.ownerOrder:0}}%</p>
          </div>
          <div class="tab_right">
            <p class="tab_title">公司中排名</p>
            <p class="tab_num">{{onlinerate.topNum?onlinerate.topNum:'--'}}</p>
          </div>
        </div>
        <div class="card_best3">
          <div class="best3_title">公司中TOP3社区</div>
          <div class="best3_list" v-if="onlinerate.mobileBiTopList&&onlinerate.mobileBiTopList.length">
            <div class="best3_item" v-for="item in onlinerate.mobileBiTopList" :key="item.regionId">
              <div class="item_num">{{item.num}}</div>
              <div class="item_name">{{item.regionName}}</div>
              <div class="item_value">{{item.ownerOrder}}%</div>
            </div>
          </div>
          <div v-else class="best3_list">
            <div class="best3_item">
              <span class="nullitem">--</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 评价情况卡片 -->
      <div class="card">
        <div class="card_header">
          <i class="iconfont iconicon-baoshihaopingshuai icon_blue"></i>
          <span class="header_text">评价情况</span>
        </div>
        <div class="card_tab">
          <div class="tab_left">
            <p class="tab_title">业主标准报事好评率</p>
            <p class="tab_num">{{evaluate.ownerOrder?evaluate.ownerOrder:0}}%</p>
          </div>
          <div class="tab_right">
            <p class="tab_title">公司中排名</p>
            <p class="tab_num">{{evaluate.topNum?evaluate.topNum:'--'}}</p>
          </div>
        </div>
        <div class="card_best3">
          <div class="best3_title">公司中TOP3社区</div>
          <div class="best3_list" v-if="evaluate.mobileBiTopList&&evaluate.mobileBiTopList.length">
            <div class="best3_item" v-for="item in evaluate.mobileBiTopList" :key="item.regionId">
              <div class="item_num">{{item.num}}</div>
              <div class="item_name">{{item.regionName}}</div>
              <div class="item_value">{{item.ownerOrder}}%</div>
            </div>
          </div>
          <div v-else class="best3_list">
            <div class="best3_item">
              <span class="nullitem">--</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 投诉情况卡片 -->
      <div class="card">
        <div class="card_header">
          <i class="iconfont iconicon-tousuqingkuang icon_blue"></i>
          <span class="header_text">投诉情况</span>
        </div>
        <div class="card_tab">
          <div class="tab_left">
            <p class="tab_title">业主标准报事投诉量</p>
            <p class="tab_num">{{complainquantity.ownerOrder?complainquantity.ownerOrder:0}}</p>
          </div>
          <div class="tab_right">
            <p class="tab_title">公司中排名</p>
            <p class="tab_num">{{complainquantity.topNum?complainquantity.topNum:'--'}}</p>
          </div>
        </div>
        <div class="card_best3">
          <div class="best3_title">公司中TOP3社区</div>
          <div class="best3_list" v-if="complainquantity.mobileBiTopList&&complainquantity.mobileBiTopList.length">
            <div class="best3_item" v-for="item in complainquantity.mobileBiTopList" :key="item.regionId">
              <div class="item_num">{{item.num}}</div>
              <div class="item_name">{{item.regionName}}</div>
              <div class="item_value">{{item.ownerOrder}}</div>
            </div>
          </div>
          <div v-else class="best3_list">
            <div class="best3_item">
              <span class="nullitem">--</span>
            </div>
          </div>
        </div>
      </div>
    <div class="time">{{footertime}}</div>
    </div>
    <div class="footer_btn" v-if="cookieb.qdVersion">
      <div class="save_btn" @click="saveimg"><i class="iconfont iconsave"></i>保存至相册</div>
      <div class="share_btn" @click="shareimg"><i class="iconfont iconweixin"></i>分享至微信</div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { Indicator } from 'mint-ui';
import { Toast } from 'mint-ui';
import { Button } from 'mint-ui';
import axios from 'axios';
import qs from 'qs';
import $ from "jquery";
let Base64 = require('js-base64').Base64;

const clickoutside = {
    // 初始化指令
    bind(el, binding, vnode) {
        function documentHandler(e) {
            // 这里判断点击的元素是否是本身，是本身，则返回
            if (el.contains(e.target)) {
                return false;
            }
            // 判断指令中是否绑定了函数
            if (binding.expression) {
                // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                binding.value(e);
            }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener('click', documentHandler);
    },
    update() {},
    unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
    },
};

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '',
      maskshow:false,
      canshow:false,
      regionuser:'',
      cookieb:'',
      footertime:'',
      timelyfinish:{},
      onlinerate:{},
      evaluate:{},
      complainquantity:{},
      msg2: [],
      imgurl:'',
      region:'',
      regionList:[]
    }
  },
  methods:{
    sendmaidian(type,page){
      let obj1={
        AccountInfo: [],
        ApplicationInfo: [],
        BaseInfo: {
          LSE: 1,
          LV: "v3.2",
          AV: "1.1.0",
          UI: this.cookieb.mId?this.cookieb.mId:'', //用户id
          PJID: "" //社区id
          },
        NetworkInfo: [],
        PositionInfo: [],
        PageInfo: [{
          POT: new Date().getTime(),
          PCT: "",
          PI: page,
          AI: {
            platform_channel: "1"
          }
        }],
        EventInfo: [{
          EHT: new Date().getTime(),                    // 事件发生时间
          EI: type,  // 时间ID
          AI: {                                  // 额外参数
            PI: page,                // 所属页面
            platform_channel: "1"  
          }
        }]};
        let obj={}
        obj.body=JSON.stringify({logs:JSON.stringify(obj1)});
        $.ajax({
          type: "get",
          url: maidianurl,
          data: obj,
          success: function(data) {
            console.log(123);
          }
        })
    },
    saveimg(){
      console.log('保存相片');
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      // this.sendmaidian('event_CommunityDataDetails_saveClick','CommunityDataDetails');
      console.log('保存相片');
      html2canvas(document.querySelector("#region_report")).then(canvas => {
        // document.body.appendChild(canvas)
        let dataURL = canvas.toDataURL("image/png");
        console.log(dataURL)
        dataURL=dataURL.split(',')[1];
        Indicator.close();
        window.WebViewJavascriptBridge.callHandler(
          'jsCallApp',{
          "action" : "jsSaveImage",
          "entity" : {
            "image": dataURL   // * 保存的图片Base64格式
          }
        })
      });
    },
    shareimg(){
      console.log('分享相片')
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      // this.sendmaidian('event_CommunityDataDetails_forwardClick','CommunityDataDetails');
      html2canvas(document.querySelector("#region_report")).then(canvas => {

        // document.body.appendChild(canvas)
        let dataURL = canvas.toDataURL("image/png");
        console.log(dataURL)
        dataURL=dataURL.split(',')[1];
        Indicator.close();
        window.WebViewJavascriptBridge.callHandler(
        'jsCallApp',{
        "action" : "jsShare",
        "entity" : { 
            "shareType" : "Direct", // 分享方式Panel表示展示面板，Direct直接分享
            "shareScene" : ["wxSession", "wxTimeline"], //Panel情况可多个，Direct只取第一个：wxSession 微信好友,wxTimeline 朋友圈,QQ QQ好友,QZone QQ空间,SocialGroup 邻聚群组, CopyLink 复制链接
            "shareContent": {  //分享内容
            "type": "Image", // 分享方式：Text 文本（text生效）, Image 大图（image生效）, Web 图文（title，text，image，url生效）
            "title": "Title", // 标题
            "text": "Text", // 内容
            "imageType": "base64", // 分享图片的类型：base64，url
            "image": dataURL, // * 分享的图片Base64格式
            }
        }
        })
      });
    },
    showlist(){
      this.canshow=!this.canshow;
      console.log(this.canshow)
      
      this.maskshow=!this.maskshow;
      if(this.maskshow){
        document.getElementById('region_report').style.height='100vh';
        document.getElementById('region_report').style.marginBottom='0px'
        document.getElementById('region_report').style.overflowY='hidden';
      }else{
        document.getElementById('region_report').style.height='auto'
        document.getElementById('region_report').style.marginBottom='44px'
        document.getElementById('region_report').style.overflowY='scroll';
      }
    },
    closelist(item){
      this.canshow=false;
      this.region=item.projectName;
      // this.sendmaidian('event_CommunityDataDetails_projectSelectionClick','CommunityDataDetails');
      this.getdetail(item);
      document.getElementById('region_report').style.height='auto'
      document.getElementById('region_report').style.marginBottom='44px'
      document.getElementById('region_report').style.overflowY='scroll';
      this.maskshow=false;
    },
    handleClose(){
      this.canshow=false;
      this.maskshow=false;
      document.getElementById('region_report').style.height='auto'
      document.getElementById('region_report').style.marginBottom='44px'
      document.getElementById('region_report').style.overflowY='scroll';
    },
    getregionlist(){
      //  let obj={
      //   body:JSON.stringify({
      //     appDevice:{
      //     deviceId:"2.0.0_10000",
      //     OSVersion:"1.0.",
      //     qdDevice:"IphoneX",
      //     qdPlatform:"Ios",
      //     qdVersion:"5.1.4"
      //     },
      //     appUser:{
      //       curMemberId:"2019031316421862531",
      //       thirdId:"2019031316421862531"
      //     },
      //     orderBy:"projectName",
      //     pageNo:1,
      //     pageSize:100
      //     }),
      //     userToken:"v1_UU5LQm56KzdLYnBwT3BqM1JSNWNhSzJVN2F2ZksvN2pqOW5MVUxkSXk1VXI0WkNEUk5XNjJJQ0lWQ25ncjZ5T0dtRjdCMk93OHZuUWEvWDhiUVlHS2Y4MnEwMmZ1aFNtaVlQZkJyOUlJb3QxdHNtQ1huZkFjcHdiMHJrRWJWWmh4a2tiSXpvNy9SbGtaRUpGeHRJMzJ6RWxEelRHa05uek9KWkF3ME5GQW1rTU1xMFE3a28yZENDbTh6MG5GL0NsWVRtendRUjJaVHpPTkczeTZjTVBNM2x4N2xBNld1V2J6MUFzN00rMTRpdGMxRkd5bG9PamhGWERHZGsyV01ZQmVCOGYxOWZEdXNRWlZTejNna3B6QWhuOExEeDducWJTeAoPNW_m7GQMtcVOC-TXPLWPYqkxZGPSkRgJzeC0EL2Bzdrfu4KP6lHZwMB1GXNVY3bq6_AyQ944_8UszPzPr_kMQiKG0SQPRuDEFIdedqi2B61urDS0tK_MddS45aVDwhStAsFhvDk7VLFaLt9ChLbUcfoKVlxA2R8g-oSXn5I."
      //   }

      let obj={
        body:JSON.stringify({
        appDevice:{
          deviceId:this.cookieb.deviceId?this.cookieb.deviceId:'',
          OSVersion:this.cookieb.OSVersion?this.cookieb.OSVersion:'',
          qdDevice:this.cookieb.qdDevice?this.cookieb.qdDevice:'',
          qdPlatform:this.cookieb.qdPlatform?this.cookieb.qdPlatform:'',
          qdVersion:this.cookieb.qdVersion?this.cookieb.qdVersion:''
        },
        appUser:{
          curMemberId:this.cookieb.mId?this.cookieb.mId:'',
          thirdId:this.cookieb.aId?this.cookieb.aId:''
        },
        orderBy:"projectName",
        pageNo:1,
        pageSize:100
        }),
        // userToken:this.cookieb.userToken?this.cookieb.userToken:''
      }
      if(this.cookieb.userToken){
        obj.userToken=this.cookieb.userToken?this.cookieb.userToken:''
      }
      axios.post('/im/contacts/getProjectListOrderBy',qs.stringify(obj)).then((res)=>{
        if(res.data.code==200){
          this.regionList=res.data.data.projectInfoList
          if(this.regionList.length){
            this.region=this.regionList[0].projectName;
            this.getdetail(this.regionList[0]);
          }
          
        }
      })
    },
    getdetail(item){
      console.log(item,123);
        // let obj={
        // body:JSON.stringify({
        //   appDevice:{
        //   deviceId:"2.0.0_10000",
        //   OSVersion:"1.0.",
        //   qdDevice:"IphoneX",
        //   qdPlatform:"Ios",
        //   qdVersion:"5.1.4"
        //   },
        //   appUser:{
        //     curMemberId:"2019031316421862531",
        //     thirdId:"2019031316421862531"
        //   },
        //   projectId:"201901211101317888e"
        //   }),
        //   userToken:"v1_UU5LQm56KzdLYnBwT3BqM1JSNWNhSzJVN2F2ZksvN2pqOW5MVUxkSXk1VXI0WkNEUk5XNjJJQ0lWQ25ncjZ5T0dtRjdCMk93OHZuUWEvWDhiUVlHS2Y4MnEwMmZ1aFNtaVlQZkJyOUlJb3QxdHNtQ1huZkFjcHdiMHJrRWJWWmh4a2tiSXpvNy9SbGtaRUpGeHRJMzJ6RWxEelRHa05uek9KWkF3ME5GQW1rTU1xMFE3a28yZENDbTh6MG5GL0NsWVRtendRUjJaVHpPTkczeTZjTVBNM2x4N2xBNld1V2J6MUFzN00rMTRpdGMxRkd5bG9PamhGWERHZGsyV01ZQmVCOGYxOWZEdXNRWlZTejNna3B6QWhuOExEeDducWJTeAoPNW_m7GQMtcVOC-TXPLWPYqkxZGPSkRgJzeC0EL2Bzdrfu4KP6lHZwMB1GXNVY3bq6_AyQ944_8UszPzPr_kMQiKG0SQPRuDEFIdedqi2B61urDS0tK_MddS45aVDwhStAsFhvDk7VLFaLt9ChLbUcfoKVlxA2R8g-oSXn5I."
        // }
      let obj={
        body:JSON.stringify({
        appDevice:{
          deviceId:this.cookieb.deviceId?this.cookieb.deviceId:'',
          OSVersion:this.cookieb.OSVersion?this.cookieb.OSVersion:'',
          qdDevice:this.cookieb.qdDevice?this.cookieb.qdDevice:'',
          qdPlatform:this.cookieb.qdPlatform?this.cookieb.qdPlatform:'',
          qdVersion:this.cookieb.qdVersion?this.cookieb.qdVersion:''
        },
        appUser:{
          curMemberId:this.cookieb.mId?this.cookieb.mId:'',
          thirdId:this.cookieb.aId?this.cookieb.aId:''
        },
        projectId:item.projectId
        }),
        // userToken:this.cookieb.userToken?this.cookieb.userToken:''
      }
      if(this.cookieb.userToken){
        obj.userToken=this.cookieb.userToken?this.cookieb.userToken:''
      }
      axios.post('/task/getCommunityWorkBriefing',qs.stringify(obj)).then((res)=>{
        if(res.data.code==200){
          console.log(res);
          this.complainquantity=res.data.data.regionComplainQuantity;
          this.timelyfinish=res.data.data.regionTimelyFinishRate;
          this.onlinerate=res.data.data.regionOnlineCountRate;
          this.evaluate=res.data.data.regionEvaluateRate;
          this.regionuser=res.data.data.workTitle;
          this.footertime=res.data.data.workMonth;
        }
      })
    },
    getcookie(name){
        var that = this;　　　　
        //检查这个cookie是否存在，不存在就为 -1
        let c_start = document.cookie.indexOf(name + "=")
        if (c_start != -1) {
            //获取cookie值的开始位置
            c_start = c_start + name.length + 1;
            
            //通过";"号是否存在来判断结束位置
            let c_end = document.cookie.indexOf(";", c_start);

            if (c_end == -1){
                c_end = document.cookie.length;
            }
            //通过substring()得到了值
            this.cookieb = unescape(document.cookie.substring(c_start, c_end))
            this.cookieb=Base64.decode(this.cookieb)
            this.cookieb= JSON.parse(this.cookieb);
            if(!this.cookieb.userToken&&!this.cookieb.saas_sessionId_online){
              Toast({
                message: '请更新至最新版本，即可查看简报内容',
                position: 'bottom',
                duration: 5000
              });
            }
        }else{
          Toast({
            message: '请更新至最新版本，即可查看简报内容',
            position: 'bottom',
            duration: 5000
          });
        }　　　　　　　　　
    
    }
  },
  directives: {clickoutside},
  mounted:function(){
    this.getcookie('X');
    document.title="社区工作简报-报事"
    this.getregionlist();
  },
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#region_report{
  height: 100%;
  margin-bottom: 44px;
  overflow-y: scroll;
  /* display: flex; */
}
#region_report .region_header{
  position: relative;
  text-align: left;
  padding: 0 16px;
  z-index: 999;
  background: #fff;
}
#region_report .region_header .chooseregion{
  display: inline-block;
  width: 100%;
  height: 49px;
  line-height: 49px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  /* border-top: 1px solid #E7E7E7; */
  /* border-bottom: 1px solid #E7E7E7;  */
}
#region_report .chooseList{
  position: absolute;
  z-index: 999;
  width: 100%;
  max-height: 300px;
  overflow-y: scroll;
  top: 49px;
  left: 0;
  padding: 0 16px 16px;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(102,102,102,0.20);
}
#region_report .chooseList .choose_item{
  display: inline-block;
  width: 100%;
  height: 49px;
  line-height: 49px;
  /* padding: 10px 0; */
  position: relative;
  /* padding: 10px 0px; */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  /* border-bottom: 1px solid #E7E7E7; */
}
#region_report .chooseList .choose_item:after{
  position: absolute;
  content: "";
  display: block;
  bottom: 0;
  border-bottom: 1px solid #e7e7e7;
  transform: scaleY(0.5);
  width: 100%;
}
#region_report .chooseList .choose_item:first-child{
  display: inline-block;
  width: 100%;
  border-top: none;
  /* border-top: 1px solid #E7E7E7; */
  /* border-bottom: 1px solid #E7E7E7; */
}
#region_report .iconfont{
  margin-right:4px; 
}
#region_report .spec_icon{
  float: right;
  color:#999999;
}
#region_report .region_title{
  line-height: 40px;
  text-align: left;
  padding: 8px 16px 0;
  font-size: 15px;
  color: #666666;
}
#region_report .card{
  max-height: 280px;
  background: #ccc;
  /* width: 90%; */
  margin: 8px 16px 20px;
  /* margin-bottom:20px; */
  background: #FFFFFF;
  box-shadow: 0 0 8px 0 rgba(0,0,0,0.10);
}
#region_report .card_big{
  max-height: 510px;
  background: #ccc;
  /* width: 90%; */
  margin: 8px 16px 20px;
  /* margin-bottom:20px; */
  background: #FFFFFF;
  box-shadow: 0 0 8px 0 rgba(0,0,0,0.10);
}
#region_report .card_header{
  height: 48px;
  text-align: left;
  color: #333333;
  line-height: 48px;
  padding: 0 16px;
  position: relative;
  /* border-bottom: 1px solid #E7E7E7; */
}
#region_report .card_header:after{
  position: absolute;
  left: 0;
  right: 0;
  content: "";
  display: block;
  bottom: 0;
  border-bottom: 1px solid #e7e7e7;
  transform: scaleY(0.5);
  width: 100%;
}
#region_report .header_text{
  font-size: 16px;
  font-weight: bold;
}
#region_report .icon_blue{
  color: #4BB6FF;
}
#region_report .card_tab{
  height: 60px;
  /* border-bottom: 1px solid #E7E7E7; */
  text-align: left;
  position: relative;
}
#region_report .card_tab:after{
  position: absolute;
  left: 0;
  right: 0;
  content: "";
  display: block;
  bottom: 0;
  border-bottom: 1px solid #e7e7e7;
  transform: scaleY(0.5);
  width: 100%;
}
.tab_left{
  float:left;
  width: 60%;
  height: 44px;
  margin: 8px 0;
  padding-left:16px; 
}
.tab_right{
  float: right;
  width: 40%;
  height: 44px;
  margin: 8px 0;
  /* border-left: 1px solid #E7E7E7; */
  padding-left:16px; 
  position: relative;
}
.tab_right:after{
  position: absolute;
  left: 0;
  /* right: 0; */
  content: "";
  display: block;
  bottom: 0;
  border-left: 1px solid #e7e7e7;
  transform: scaleX(0.5);
  height: 100%;
}
.tab_title{
  font-size: 13px;
  height: 16px;
  line-height: 16px;
  color: #666666;
}
.tab_num{
  font-size: 20px;
  height: 20px;
  margin-top: 8px;
  line-height: 20px;
  color: #0084FF;
  font-weight: 600;
}
#region_report .card_big .card_best3{
  max-height: 150px;
  text-align: left;
  position: relative;
  /* border-bottom: 1px solid #E7E7E7; */
}
#region_report .card_big .card_best3:after{
  position: absolute;
  left: 0;
  right: 0;
  content: "";
  display: block;
  bottom: 0;
  border-bottom: 1px solid #e7e7e7;
  transform: scaleY(0.5);
  width: 100%;
}
#region_report .card .card_best3{
  max-height: 280px;
  text-align: left;
}
.best3_title{
  height: 48px;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  line-height: 48px;
  /* border-bottom: 1px solid #E7E7E7; */
  margin: 0 16px;
  position: relative;
}
.best3_title:after{
  position: absolute;
  left: 0;
  right: 0;
  content: "";
  display: block;
  bottom: 0;
  border-bottom: 1px solid #e7e7e7;
  transform: scaleY(0.5);
  width: 100%;
}
.best3_list{
  max-height: 120px;
  padding: 16px 16px;
}
.best3_item{
  width: 100%;
  height: 16px;
  margin-bottom: 10px;
  line-height: 16px;
  /* padding:5px 10px 5px;  */
}
.best3_item:last-child{
  width: 100%;
  height: 16px;
  margin-bottom: 0;
}
.item_num{
  float: left;
  width: 16px;
  height: 16px;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  line-height: 16px;
  padding-top:1px;
  border-radius: 8px;
  background: #0084FF;
  margin-right: 10px;
}
.item_name{
  float: left;
  margin-right:16px; 
  width: 60%;
  height: 16px;
  font-size: 14px;
  color: #333333;
  overflow: hidden;
  white-space:nowrap; 
  text-overflow:ellipsis;
}
.item_value{
  height: 16px;
  float: right;
}

.save_btn{
  width: 50%;
  height: 44px;
  line-height: 44px;
  float: left;
  background: #0084FF;
  color: #fff;
}
.share_btn{
  width: 50%;
  height: 44px;
  line-height: 44px;
  float: left;
  background: #0084FF;
  color: #fff;
  border-left: 1px solid #fff;
}
.footer_btn{
  position: fixed;
  bottom: 0;
  width:100%;
  text-align: center;
}
.footer_btn .iconfont{
  margin-right: 6px;
}
.time{
  width: 90%;
  text-align: left;
  margin: 0 auto;
  margin-bottom: 16px;
  color: #999;
  font-size: 14px; 
}
.nullitem{
  font-size: 20px;
  font-weight: 600;
  color: #0084FF;
}
.half_border:after{
  content: "";
  display: block;
  border-bottom: 1px solid #e7e7e7;
  transform: scaleY(0.5);
  width: 100%;
}
.flow_all{
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  z-index:998;
  background: #333;
  opacity: 0.4;
}
/* div {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
} */
</style>



// WEBPACK FOOTER //
// src/views/report/RegionReport.vue